import { GameRepository } from "../../../../data/repository/game/GameRepository";
import { Message } from "../../../model/Auth";
import { Game } from "../../../model/Game";
import { ResponseState, State } from "../../../model/ResponseState";

export interface CreateGameUseCase {
  invoke: () => Promise<ResponseState<Game>>;
}

export class CreateGameUseCaseImpl implements CreateGameUseCase {
  private repo: GameRepository;

  constructor(repo: GameRepository) {
    this.repo = repo;
  }

  async invoke(): Promise<ResponseState<Game>> {
    try {
      let response = await this.repo.createGame();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
